<template>
  <div class="index">
    <div class="indexbox">
      <!-- 新闻 -->
      <div class="indexsst">
        <div class="newsimg-newText">
          <div class="news img-news" @mouseenter="autoplay = false" @mouseleave="autoplay = true">
            <el-carousel
              ref="newsCarousel"
              trigger="click"
              height="374px"
              :autoplay="autoplay"
              indicator-position="none"
              style="z-index:0;width:573px;"
              @change="carouselHandleChange"
            >
              <el-carousel-item v-for="(item, index) in carousels" :key="index" :name="'' + index">
                <div class="carousel-inner">
                  <img
                    :src="item.imgUrl"
                    :alt="item.title"
                    @click="carouselsHandleClick(item)"
                    :draggable="false"
                  />
                  <div class="carousel-title">
                    <span @click="carouselsHandleClick(item)">{{ item.title }}</span>
                    <div class="carousel-indicator">
                      <div v-for="(item, index) in carousels" :key="index"></div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="carousel-indicator">
              <div
                v-for="(item, index) in carousels"
                :key="index"
                :class="{ active: carouselActive === index }"
                @click="setActiveItem(index)"
              ></div>
            </div>
          </div>

          <div class="text-news">
            <div class="textnewHed">
              <div class="textnewHedleft">
                <img src="@/assets/newIndex/u31090.png" />
                最近更新
              </div>
              <div class="moreBtn">
                <!-- <span>查看更多</span>
                <i class="el-icon-arrow-right"></i> -->
              </div>
            </div>
            <!-- 渐变线条 -->
            <div class="gitern"></div>
            <ul class="tabs-main">
              <li v-for="(newsItem, newsIndex) in textnewsdata" :key="newsIndex">
                <div class="bordeRou"></div>
                <div
                  :title="newsItem.name"
                  @click="recentlyClick(newsIndex,newsItem)"
                  class="titleLbae onele"
                >{{ newsItem.name}}</div>
                <div class="title-news">
                  <!-- <img v-if="newsItem.ishot" style="width:100%" src="@/assets/gif007.gif" /> -->
                  <span v-if="newsItem.ishot">热</span>
                </div>
                <div class="titleNmae" v-if="newsItem.objType==1">新闻</div>
                <div class="titleNmae" v-else-if="newsItem.objType==2">微警校</div>
                <div class="titleNmae" v-else-if="newsItem.objType==3">资源</div>
                <div class="titleNmae" v-else-if="newsItem.objType==4">考试</div>
                <div class="titleNmae" v-else-if="newsItem.objType==5">调训</div>
                <div class="titleNmae" v-else-if="newsItem.objType==6">教官</div>
                <div class="titleNmae" v-else-if="newsItem.objType==7">问卷</div>
                <div class="titleLbaetime onele">{{newsItem.dateStr}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 新闻/专栏 -->
      <!-- <div class="newsColumn">
        <div class="newsModel">
          <div class="newsModelHeader">
            <div class="newsTypes">
              <div @click.prevent="newTab(0,tablistwoList[0],1)" :class="['newsTypeSwitchBtn',{'activeNewsTypesBtn': initTypeOne === 0}]">{{tablistwoList[0] ? tablistwoList[0].name : ''}}</div>
              <div @click.prevent="newTab(1,tablistwoList[1],1)" :class="['newsTypeSwitchBtn',{'activeNewsTypesBtn': initTypeOne === 1}]">{{tablistwoList[1] ? tablistwoList[1].name : ''}}</div>
            </div>
            <div @click="pushnewslist(tablistwoList[initTypeOne])" class="moreBtn">
              <span>查看更多</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="newsHeaderLine"></div>
          <ul class="smallNewsListCon">
            <li v-for="(item,index) in oneNewsList" :key="index">
              <div class="newsCon">
                <div class="spot"></div>
                <div :title="item.title" @click="newsHandleClick(item,index)" class="newsConLable">{{item.title}}</div>
              </div>
              <div class="newsDate">{{item.publishTime}}</div>
            </li>
          </ul>
        </div>
        <div class="newsModel">
          <div class="newsModelHeader">
            <div class="newsTypes">
              <div @click.prevent="newTab(2,tablistwoList[2],2)" :class="['newsTypeSwitchBtn',{'activeNewsTypesBtn': initTypeTwo === 2}]">{{tablistwoList[2] ? tablistwoList[2].name : ''}}</div>
              <div @click.prevent="newTab(3,tablistwoList[3],2)" :class="['newsTypeSwitchBtn',{'activeNewsTypesBtn': initTypeTwo === 3}]">{{tablistwoList[3] ? tablistwoList[3].name : ''}}</div>
            </div>
            <div @click="pushnewslist(tablistwoList[initTypeTwo])" class="moreBtn">
              <span>查看更多</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="newsHeaderLine"></div>
          <ul class="smallNewsListCon">
            <li v-for="(item,index) in twoNewsList" :key="index">
              <div class="newsCon">
                <div class="spot"></div>
                <div :title="item.title" @click="newsHandleClick(item,index)" class="newsConLable">{{item.title}}</div>
              </div>
              <div class="newsDate">{{item.publishTime}}</div>
            </li>
          </ul>
        </div>
        <div class="columnModel">
          <div class="columnModelHeader">
            <h2>专栏</h2>
          </div>
          <div class="newsHeaderLine"></div>
          <ul class="columnListCon">
            <li :style="`background-image: url(${item.imgurl});cursor: ${!!item.weburl ? 'pointer' : 'auto'};`" @click.prevent="openWebUrl(item.weburl)" v-for="(item,index) in columnTuList" :key="index">
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
      </div> -->

      <homeColumn></homeColumn>

      <!-- 微警校 -->
      <div class="training-school-inner">
        <div class="training-school-head">
          <div class="leftLabel">
            <img src="@/assets/newIndex/u30922.png" />
            <div>微警校</div>
          </div>
          <div class="gdbox">
            <span @click="gotoschool">查看更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="labelLine"></div>
        <div class="trainingvideo">
          <div class="trainingvideright">
            <div
              class="trainingimgli"
              v-for="(item,index) in schoolData"
              :key="index"
              @click="videolearn(index,item)"
            >
              <img :src="item.imgUrl" />
              <div>
                <div :title="item.name" class="traingimgtext onele">{{item.name}}</div>
                <div class="cityText">{{item.deptName}}</div>
                <div class="traingimgnametxtlil">
                  <div class="traintext" v-if="item.jzDicName">{{item.jzDicName}}</div>
                  <div class="traingimgflex">
                    <div class="trainicon" style="margin-right:20px">
                      <img src="@/assets/resource/u231.svg" alt />
                      {{item.visitNum}}
                    </div>
                    <div class="trainicon" style="margin-right:20px">
                      <img src="@/assets/videoimg/studycommentPlin.svg" alt />
                      <span>{{item.talkCount}}</span>
                    </div>
                    <div class="trainicon">
                      <img src="@/assets/videoimg/like.svg" style="width:12px;height:12px" />
                      <span>{{item.assistCount}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 考试咨询 -->
      <div class="test-center-centerBox">
        <div class="test-center-center">
          <div class="test-center-centerleft">
            <div class="test-center-head">
              <img src="@/assets/newIndex/test.png" />
              <div class="should">考试资讯</div>
              <div class="resourul">
                <div class="resourulli" v-for="(item,index) in tablistwoks"
                  :key="index"
                  @mouseenter="enterTabks(index)"
                  :class="{resourceIRLeactiveww:index==nowIndexTgks}"  
                  >{{item}}
                  </div>
              </div>
              <div class="gdbox">
                <span class="navLi" @click="gotoexam">查看更多</span>
                <i class="el-icon-arrow-right navLi"></i>
              </div>
            </div>
            <!-- 渐变线条 -->
            <div class="gitern"></div>
            <div class="tableliborderlicent">
            <el-table
            :data="listleft"
            style="width: 100%"
            height="100%"
            highlight-current-row
            ref="mainTable"
            header-cell-class-name="examtabHeader"
            class="homeExamTable"
            :header-cell-style="{'text-align':'center',fontSize:'16px',lineHeight:'24px'}"
            >
              <el-table-column  label="考试名称"  show-overflow-tooltip min-width="180">
                <template slot-scope="scope" >
                <span class="title-text-up" v-if="nowIndexTgks==0" style="text-align: left;" @click="btnExam(scope.row,scope.$index)">{{scope.row.title}}</span>
                <span class="title-text-up" v-if="nowIndexTgks==1" style="text-align: left;" @click="btnTestExam(scope.row)">{{scope.row.title}}</span>
              </template>       
              </el-table-column>
              <el-table-column prop="cateName" label="考试类别" align="center"  width="150"></el-table-column>
              <el-table-column prop="subjectName" label="考试科目" align="center"  width="150"></el-table-column>
              <el-table-column prop="subjectName" v-if="nowIndexTgks==0" label="考试时间" align="center"  width="280">
                <template slot-scope="scope">
                  <span class="title-text-up">{{scope.row.begintime?scope.row.begintime.substring(0,18):''}} {{scope.row.endtime?scope.row.endtime.substring(0,18):''}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" v-if="nowIndexTgks==1" label="考试模式" align="center"   width="150">
                <template slot-scope="scope">
                  <span class="title-text-up">练习考试</span>
                </template>
              </el-table-column>
               <el-table-column  align="center" label="考试时长"  width="100">
                <template slot-scope="scope">
                  <span class="title-text-up">{{scope.row.times}} 分钟</span>
                </template>
              </el-table-column>
               <el-table-column prop="deptName"  align="center" label="主办单位" show-overflow-tooltip min-width="100">
              </el-table-column>
            </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- 教官库 -->
      <!-- <div class="InstructorLibrary">
        <div class="InstructorLibrarybox">
          <div class="InstructorLibraryleft">
            <div class="InstructorLibraryhead">
              <img src="@/assets/newIndex/u30864.png" />
              <div class="shoulds">教官库</div>
              <div class="gdboxright">
                <span class="navLi" @click="gototeacher"><span>查看更多</span><i class="el-icon-arrow-right"></i></span>
              </div>
            </div>
            <div class="gitern"></div>
            <div class="InstructorLibraryName">
              <el-carousel trigger="click" height="250px" :interval="7000" class="focus">
                <el-carousel-item v-for="(item,index) in drillmasters" :key="index" class="listli">
                  <div v-for="(items,indexs) in item" :key="indexs" @click="teacherOne(items)">
                    <img
                      :src="items.photo"
                      :alt="items.name"
                      :draggable="false"
                      style="cursor: pointer;"
                    />
                    <div>{{items.name}}</div>
                    <div>{{items.deptName}}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="InstructorLibraryright">
            <div class="InstructorLibraryrightli">
              <img src="@/assets/newIndex/u30723.png" />
              <div class="Nmae">部级教官</div>
              <div class="sum">{{TearcherTjData.buji}}</div>
              <div class="units">人</div>
            </div>
            <div class="InstructorLibraryrightli">
              <img src="@/assets/newIndex/u30718.png" />
              <div class="Nmae">省级教官</div>
              <div class="sum">{{TearcherTjData.shengji}}</div>
              <div class="units">人</div>
            </div>

            <div class="InstructorLibraryrightli">
              <img src="@/assets/newIndex/u31110.png" />
              <div class="Nmae">州市级教官</div>
              <div class="sum">{{TearcherTjData.dishiji}}</div>
              <div class="units">人</div>
            </div>
            <div class="InstructorLibraryrightli">
              <img src="@/assets/newIndex/u30727.png" />
              <div class="Nmae">区县教官</div>
              <div class="sum">{{TearcherTjData.quxianji}}</div>
              <div class="units">人</div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 选择省市区 -->
      <!-- <linecom></linecom> -->
    </div>

    <el-dialog width="70%" :visible.sync="enterDialogVisible" center @close="closeDialog">
      <EnterExamDialog v-if="enterDialogVisible" :titleExam="titleExam"></EnterExamDialog>
    </el-dialog>

    <el-dialog class="dialog" title="最近更新" :visible.sync="recentlyFlag" width="50%">
      <div class="cate">
        <div class="cate_police">
          <div class="cate-all">类型选择：</div>
          <div class="subject">
            <span
              v-for="(item, index) in recentlyType"
              :key="index"
              :class="{heightlight : recentlyTypeID==index}"
              @click="recentlyTypeClick(index,item)"
            >{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="tabsmainBox">
        <ul class="tabs-main1">
          <li v-for="(newsItem, newsIndex) in recentlyData" :key="newsIndex">
            <div class="bordeRou1"></div>
            <div
              @click="recentlyClick(newsIndex,newsItem)"
              class="titleLbae1 onele"
            >{{ newsItem.name}}</div>
            <div class="titleNmae1" v-if="newsItem.objType==1">新闻</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==2">微警校</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==3">资源</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==4">考试</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==5">调训</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==6">教官</div>
            <div class="titleNmae1" v-else-if="newsItem.objType==7">问卷</div>
            <div class="titleLbaetime1 onele">{{newsItem.createTime}}</div>
          </li>
        </ul>
        <div style="text-align:center">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="total,prev, pager, next,jumper"
            :page-size="recentlylistQuery.limit"
            :current-page.sync="recentlylistQuery.page"
            :total="recentlydataCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- <piaoC v-if="piaocShow" :piaocShow="piaocShow"></piaoC> -->
  </div>
</template>


<script>
import { getInfo } from '@/utils/auth';
import * as homes from '@/api/clientshome/index.js';
import * as resources from '@/api/resources';
import EnterExamDialog from '../exam/components/enterExamDialog';
import linecom from '@/components/linecom/index';
import piaoC from '@/components/piaoc/index';
import homeColumn from './components/homeColumn/index.vue';

export default {
  components: { EnterExamDialog, linecom, piaoC, homeColumn },
  data() {
    return {
      tablistwoks:['正式考试','练习考试'],
       nowIndexTgks:0,
        zuobtn:false,
         youbtn:true,
      recentlyType: [
        { name: '全部', objType: null },
        { name: '新闻', objType: 1 },
        { name: '微警校', objType: 2 },
        { name: '资源', objType: 3 },
        { name: '考试', objType: 4 },
        { name: '调训', objType: 5 },
        { name: '教官', objType: 6 },
        { name: '问卷', objType: 7 },
      ],
      recentlyTypeID: 0,
      recentlyFlag: false,
      recentlylistQuery: {
        page: 1,
        limit: 10,
        type: null,
        name: null,
      },
      recentlydataCount: 0,
      recentlyData: [],

      enterDialogVisible: false, //进入考试弹框
      titleExam: '',

      indexactive: 0,
      headerImg: require('@/assets/newIndex/hederImg.png'),
      criminalImg: require('@/assets/newIndex/u31088.jpg'),
      carousels: [],
      resourcesList: [],
      autoplay: true,
      carouselActive: 0,
      navs: [
        {
          path: '/home',
          title: '首页',
        },
        {
          path: '/mooc',
          title: '微警校',
        },
        {
          path: '/sourceslist',
          title: '资源中心',
        },
        {
          path: '/exam',
          title: '考试中心',
        },
        {
          path: '/train',
          title: '调训中心',
        },
        {
          path: '/diaoa',
          title: '教官库',
        },
        {
          path: '/certificate',
          title: '电子证书',
        },
        {
          path: '/diaoy',
          title: '问卷测评',
        },
      ],
      textnewsdata: [],
      schoolData: [],
      courseData: [],
      TearcherTjData: '',
      listleft: [],
      listright: [],
      tablist: [
        {
          name: '最新资讯',
          id: 0,
          imgUrl: require('@/assets/newIndex/u30917.png'),
          imgUrlActive: require('@/assets/newIndex/u30917Active.png'),
        },
        {
          name: '调训管理',
          id: 1,
          imgUrl: require('@/assets/newIndex/u30876.png'),
          imgUrlActive: require('@/assets/newIndex/u30876Active.png'),
        },
        {
          name: '学习资源',
          id: 2,
          imgUrl: require('@/assets/newIndex/u30875.png'),
          imgUrlActive: require('@/assets/newIndex/u30875Active.png'),
        },
        {
          name: '课程专题',
          id: 3,
          imgUrl: require('@/assets/newIndex/u30912.png'),
          imgUrlActive: require('@/assets/newIndex/u30912Active.png'),
        },
      ],
      nowIndex: 0,
      drillmasters: [],
      tablistwoList: [],
      remediumListTab: [],
      learningResourceTab: [],
      specialTabList: [],
      nowIndexspecial: 0, //课程的id
      nowIndexResource: 0, //资源的id
      nowIndexResourceClassDicId: 0, //资源的类别Id
      nowIndexremeD: 0, //调训的ID
      nowIndexremeDclassLevel: 0, //调训的类别Id
      nowIndexTg: 0, //新闻的ID
      nowIndexTgCareId: 0,
      newslistST: [], //最新消息的列表
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      remediumList: [],
      columnListOne: [],
      columnListTwo: [],
      templates: '',
      NewMesTongJi: {},
      TrainTongJi: {},
      DocumentTongJi: {},
      piaocShow: true,
      specialId: 1,
      flgIndex: false,
      paths: '/home',
      rightList:[],
      leftList:[],

      initTypeOne: 0,
      oneNewsList: [],
      initTypeTwo: 2,
      twoNewsList: [],
      columnTuList: [],
    };
  },
  created() {
    this.templates = this.$store.getters.templates;
    this.GetCourseList();
    this.Gethomeimglist();
    this.GetExamZsList();
    // this.GetExamMyList();
    // this.GetTearcherList();
    // this.getTongJI();
    // this.getGetSecondList(62, this.tablistwoList);

    // this.getPmiDictionary(9, this.remediumListTab);
    // this.getPmiDictionary(51, this.learningResourceTab);
    // this.Getresources();
    // this.Gethometextlist();  //在获取字典的时候调用
    this.Getrecentlylist();
    // this.GetTrainList();     //在获取字典的时候调用
    // this.GetTearcherTj();
    // this.getColumnList();
    // this.getMoocSpecialList();
  },
  mounted(){},
  watch: {
    paths: {
      handler: function (val, oldVal) {
        this.getRouterName(this.paths);
      },
    },
  },
  methods: {
    enterTabks(index,item){
      this.nowIndexTgks=index
      if(index==0){
        if(this.leftList.length ==0){
           this.GetExamZsList() 
        }else{
          this.listleft=this.leftList
        }
      }else{
        if(this.rightList.length ==0){
          this.GetExamMyList()
        }else{
           this.listleft=this.rightList
        }
      }
    },
    getRouterName(roterNmae) {
      switch (roterNmae) {
        case '/home':
          this.flgIndex = true;
          this.indexactive = 0;
          this.$store.commit('SET_TABQIT', this.indexactive);

          break;
        case '/mooc':
          this.flgIndex = false;
          this.indexactive = 1;
          this.$store.commit('SET_TABQIT', this.indexactive);
          this.$router.push('/mooc');
          setTimeout(() => {
            location.reload();
          }, 500);
          break;
        case '/sourceslist':
          this.flgIndex = false;
          this.indexactive = 2;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/exam':
          this.flgIndex = false;
          this.indexactive = 3;
          this.$store.commit('SET_TABQIT', this.indexactive);
          this.$router.push('/exam');
          setTimeout(() => {
            location.reload();
          }, 500);
          break;
        case '/train':
          this.flgIndex = false;
          this.indexactive = 4;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/diaoa':
          this.flgIndex = false;
          this.indexactive = 5;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/certificate':
          this.flgIndex = false;
          this.indexactive = 7;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/dowload':
          this.flgIndex = false;
          this.indexactive = 8;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
        case '/diaoy':
          this.flgIndex = false;
          this.indexactive = 6;
          this.$store.commit('SET_TABQIT', this.indexactive);
          break;
      }
    },
    getHomeCourseList() {
       this.courseData=[]
      homes
        .getHomeCourseList({ specialId: this.specialId, isshow: true })
        .then((res) => {
          this.courseData = res.result;
        });
    },
    getMoocSpecialList() {
      homes.GetMoocSpecialList({ top: 5 }).then((res) => {
        this.specialTabList = res.result;
        this.specialId = res.result[0].id;
        this.getHomeCourseList();
      });
    },
    // getTongJI() {
    //   homes.HomeNewMesTongJi().then((res) => {
    //     this.NewMesTongJi = res.result;
    //   });
    // },
    handOptions1(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val);
      }
    },
    handOptions2(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val);
      }
    },
    handOptions3(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val);
      }
    },
    handOptions4(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val);
      }
    },
    getColumnList() {
      homes.getColumnList().then((res) => {
        let list = res.result;
        this.columnTuList = [];
        list.forEach((item,index)=>{
          if(index < 5){
            this.columnTuList.push(item);
          }
        });
      });
    },
    //点击跳转到专栏页面
    goSpecialColumn(item) {
      if (item.weburl) {
        window.open(item.weburl);
      } else if (item.isurl) {
        this.$router.push({
          path: '/home/specialColumn',
          query: {
            id: item.id,
            type: item.type,
          },
        });
      }
    },
    // 微警校数据
    gotoschool() {
      this.paths = '/mooc';
    },
    newsVideo(id) {
      this.$router.push('/studyclassDetail?id=' + id);
    },
    GetCourseList() {
      homes.getDocWkList({ top: 10 }).then((res) => {
        this.schoolData = res.result;
      });
    },
    // 图片新闻数据
    Gethomeimglist() {
      homes.Gethomeimglist({ top: 6 }).then((res) => {
        this.carousels = res.result;
      });
    },
    // 获取文字新闻列表
    Gethometextlist(type) {
      let para = {
        top: 8,
        cateId: this.nowIndexTgCareId,
      };
      this.newslistST=[]
      homes.Gethometextlist(para).then((res) => {
        if(type === 1){
          this.oneNewsList = res.result;
        }else if(type === 2){
          this.twoNewsList = res.result;
        }
      });
    },
    // 获取recently最近更新
    Getrecentlylist() {
      let para = {
        top: 8,
        // cateId: this.nowIndexTgCareId,
      };
      homes.HomeGetNewMes(para).then((res) => {
        this.textnewsdata = res.result;
      });
    },
    handleSizeChange(val) {
      this.recentlylistQuery.limit = val;
      this.HomeGetNewMesLis1();
    },
    handleCurrentChange(val) {
      this.recentlylistQuery.page = val;
      this.HomeGetNewMesLis1();
    },
    // 最近更新的更多弹窗
    recentlylist() {
      this.recentlyFlag = true;
      this.HomeGetNewMesLis1();
    },
    // 获取recently最近更新更多列表
    HomeGetNewMesLis1() {
      homes.HomeGetNewMesList(this.recentlylistQuery).then((res) => {
        this.recentlyData = res.data;
        this.recentlydataCount = res.count;
      });
    },
    recentlyTypeClick(index, item) {
      this.recentlyTypeID = index;
      // console.log(item);
      this.recentlylistQuery.type = item.objType;
      this.HomeGetNewMesLis1();
    },
    // 点击最近更新跳转页面
    recentlyClick(index, item) {
      if (item.objType == 1) {
        this.$router.push({
          path: '/home/newsgetone',
          query: {
            CateId: this.nowIndexTgCareId,
            id: item.objId,
          },
        });
      } else if (item.objType == 2) {
        this.$router.push('/studyclassDetail?id=' + item.objId);
      } else if (item.objType == 3) {
        resources.DocumentRead(item.objId).then((res) => {});
        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: item.objId,
          },
        });
      } else if (item.objType == 4) {
      } else if (item.objType == 5) {
        this.$router.push({
          path: '/train/trainclass',
          query: {
            id: objId,
          },
        });
      } else if (item.objType == 6) {
        this.$router.push({
          path: '/diaoa/personData',
          query: {
            id: item.objId,
          },
        });
      } else if (item.objType == 7) {
      }
    },
    // 获取院校链接数据
    CmsNavigationLoad() {
      let para = {
        page: 1,
        limit: 20,
        // type:'',
      };
      homes.CmsNavigationLoad(para).then((res) => {
        res.data.forEach((element) => {
          if (element.type == 1) {
            this.options1.push(element);
          }
          if (element.type == 2) {
            this.options2.push(element);
          }
          if (element.type == 3) {
            this.options3.push(element);
          }
          if (element.type == 4) {
            this.options4.push(element);
          }
        });
      });
    },
    //获取考试数据
    GetExamZsList() {
      this.listleft=[]
      homes.GetExamZsList({ top: 8 }).then((res) => {
        this.leftList=res.result
        this.listleft = res.result;
      });
    },
    GetExamMyList() { 
      this.listleft=[]
      homes.GetExamMyList({ top: 8 }).then((res) => {
        this.rightList=res.result
        this.listleft = res.result;
      });
    },
    btnExam(item) {
      localStorage.setItem('paperId', item.paperId);
      localStorage.setItem('Id', item.id);
      if (getInfo('tokens')) {
        this.titleExam = item.title;
        this.enterDialogVisible = true;
      } else {
        window.clikLogin();
      }
    },
    //关闭弹窗
    closeDialog() {
      localStorage.removeItem('paperId');
      localStorage.removeItem('Id');
      this.enterDialogVisible = false;
    },
    gotoexam() {
      this.paths = '/exam';
    },
    //点击模拟考试
    btnTestExam(row) {
      this.$router.push({
          path: '/simulationExam',
        });
      localStorage.setItem('paperId', row.paperId);
      localStorage.setItem('Id', row.id);
    },
    //优秀教官
    gototeacher() {
      this.$router.push('/diaoa');
    },
    GetTearcherList() {
      homes.GetTearcherList({ top: 25 }).then((res) => {
        // console.log(res);
        this.drillmasters = res.result;
        this.forphoto(this.drillmasters);
      });
    },
    // 教官 统计
    // GetTearcherTj() {
    //   homes.GetTearcherTj().then((res) => {
    //     this.TearcherTjData = res.result;
    //   });
    // },
    forphoto(list) {
      // list是要进行拆分的数组数组
      //    思路：将整组图片数据进行拆分，变成二维数组，一个数组里面放八个数据，多的放下一个数组
      const listResult = []; // 最终返回的二维数组
      for (let i = 0; i < Math.ceil(list.length / 5); i++) {
        listResult[i] = [];
        // 最终获得多少个二维数组
        for (let j = 0; j < 5; j++) {
          // 如果是最后一个板块
          if (i === Math.ceil(list.length / 5) - 1) {
            if (Math.ceil(list.length % 5) !== 0) {
              // 只有最后一个板块的数据在余数以内的才赋值
              if (j < Math.ceil(list.length % 5)) {
                listResult[i][j] = list[i * 5 + j];
              }
            } else {
              // 如果刚好整整一个板块，则全部附上值
              listResult[i][j] = list[i * 5 + j];
            }
          } else {
            listResult[i][j] = list[i * 5 + j];
          }
        }
      }
      this.drillmasters = listResult;
    },
    // 跳转教官详细页面
    teacherOne(item) {
      this.$router.push({
        path: '/diaoa/personData',
        query: {
          id: item.id,
        },
      });
    },
    // 调训跳转详细页面
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    // 课程
    specialTab(index, item) {
      this.nowIndexspecial = index;
      this.specialId = item.id;
      this.getHomeCourseList();
    },
    // 调训
    remeDnewTab(index, item) {
      this.nowIndexremeD = index;
      this.nowIndexremeDclassLevel = item.id;
      this.GetTrainList();
    },
    // 新闻切换
    newTab(index, item, type=null){
      if(type === 1){
        this.initTypeOne = index;
      }else if(type === 2){
        this.initTypeTwo = index;
      }
      this.nowIndexTg = index;
      this.nowIndexTgCareId = item.id;
      this.Gethometextlist(type);
    },
    ResourceTab(index, item) {
      this.nowIndexResource = index;
      this.nowIndexResourceClassDicId = item.id;
      this.Getresources();
    },
    enterTab(index) {
      this.nowIndex = index;
      if(index==0){
        // if(this.tablistwoList.length==0){
        //   this.getGetSecondList(62, this.tablistwoList);
        // }
      }else if(index==1){
        if(this.remediumListTab.length==0){
          homes.HomeTrainTongJi().then((res) => {
            this.TrainTongJi = res.result;
          });
          this.getPmiDictionary(9, this.remediumListTab);
        }
      }else if(index==2){
        if(this.learningResourceTab.length==0){
          resources.GetDocSecondList().then((res) => {
            if(res.result.length>0){
                this.learningResourceTab= res.result;
                this.nowIndexResourceClassDicId = res.result[0].id;
                this.Getresources();
            }
            homes.HomeDocumentTongJi().then((res) => {
              this.DocumentTongJi = res.result;
            });
          });
        }
      }else if(index==3){
        //this.specialTabList=[]
          if(this.specialTabList.length==0)
        {
        this.getMoocSpecialList();
        }
      }
    },
    TabIndexType(index, path) {
      this.indexactive = index;
      this.$router.push(path);
    },
    // tab切换
    toggleTabs(index) {
      this.nowIndex = index;
    },
    // 获取调训的数据
    GetTrainList() {
       this.remediumList=[]
      homes
        .GetTrainList({ top: 9, classLevel: this.nowIndexremeDclassLevel })
        .then((res) => {
          // console.log(res.result);
          this.remediumList = res.result;
          res.result.forEach((element, index) => {
            let star = element.starTime.slice(0, 10);
            this.remediumList[index].starTime = star;
            let end = element.endtime.slice(0, 10);
            this.remediumList[index].endtime = end;
          });
        });
    },
    // 获取资源列表
    Getresources() {
      let data = {
        Page: 1,
        Limit: 12,
        State: 1,
        ClassDicId: this.nowIndexResourceClassDicId,
      };
      this.resourcesList=[]
      resources.getDocumentByClass(data).then((res) => {
        this.resourcesList = res.result;
      });
    },
    videolearn(index, item) {
      resources.DocumentRead(item.id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: item.id,
        },
      });
    },
    // 点击更多进入新闻列表页面
    pushnewslist(row={}) {
      this.$router.push({
        path: '/home/newsList',
        query: {
          CateId: row.id > 0 ? row.id : this.nowIndexTgCareId,
        },
      });
    },
    // 点击跳转新闻详细页面
    newsHandleClick(item, index) {
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          CateId: this.nowIndexTgCareId,
          id: item.id,
        },
      });
    },
    async getGetSecondList(index, arr) {
      return '废弃'
      this.listQuery.isshow = true;
      let response = await homes.GetSecondList(this.listQuery)
      response.result.forEach((e, i) => {
        arr.push({ name: e.name.substring(0, 4), id: e.id });
      });
      this.nowIndexTgCareId = response.result[0].id;
      await this.Gethometextlist(1);
      this.nowIndexTgCareId = response.result[2].id;
      await this.Gethometextlist(2);
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      homes
        .getPmiDic(this.listQuery)
        .then((response) => {
          response.result.forEach((e, i) => {
            arr.push({ name: e.name, id: e.id });
            if (index == 9 && i == 0) {
              this.nowIndexremeDclassLevel = arr[0].id;
              this.GetTrainList();
            } else if (index == 51 && i == 0) {
              this.nowIndexResourceClassDicId = arr[0].id;
              this.Getresources();
            }
          });
          // console.log(response.data.name)
        })
        .catch(() => {
          // 
        });
    },
    carouselHandleChange(index) {
      this.carouselActive = index;
    },
    setActiveItem(index) {
      this.$refs.newsCarousel.setActiveItem(index);
    },
    pushTrainlist() {
      this.$router.push({
        path: '/train',
      });
    },
    pushresourceslist() {
      this.$router.push({
        path: '/sourceslist',
      });
    },
    moocZhuanti() {
      this.$router.push({
        path: '/mooc/disstationList',
      });
    },
    carouselsHandleClick(carousel) {
      let a = {
        id: carousel.id,
      };
      homes.CmsArticleReadCount(a).then((res) => {});
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          // CateId: carousel.cateId,
          id: carousel.id,
        },
      });
    },
    //打开专栏网址
    openWebUrl(weburl){
      if(weburl){
        window.open(weburl);
      }
    }
  },
};
</script>
<style>
.dialog > .el-dialog > .el-dialog__header {
  padding: 20px !important;
}
</style>
<style lang="scss" scoped>
/* 高亮 */
.heightlight {
  background-color: #3c95d6 !important;
  /* border: 1px solid #4876C4; */
  color: #f8fafc !important;
}
.cate {
  // width: 1180px;
  background: #ffffff;
  margin: 0 auto;
  padding: 0 10px;
  // box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-bottom: solid 1px #f2f2f2;
  // border-radius: 10px;
}
.cate_police {
  display: flex;
  font-size: 16px;
  margin-left: 32px;
  padding: 5px 0;
  /* height: 100px; */
}
.cate-all {
  width: 140px;
}
.subject {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
  /* background: #ECECEC; */
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  border-radius: 5px;
}
.subject > span:hover {
  border: 1px solid #3c95d6;
  color: #3c95d6;
  border-radius: 5px;
}
.index {
  background-color: #fff;
  width: 1200px;
  margin: 0 auto;
}
.indexsst {
  // position: relative;
  min-height: 442px;
}

.newheader {
  z-index: 1;
  // height: 360px;
  height: 170px;
  width: 100%;
  background-image: linear-gradient(to right, #6a23cb, #d51919);

  .navtabOne {
    width: 1100px;
    margin: 0 auto;
    padding: 50px 0 30px 0;
    .tatHeaderOne {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #fff;
      line-height: 24px;
      .litab {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        letter-spacing: 1px;
        position: relative;
        &:hover:after {
          content: '';
          display: block;
          position: absolute;
          bottom: -10px;
          left: 50%;
          right: 0;
          margin-left: -20px;
          height: 3px;
          width: 50px;
          background: #fff;
          cursor: pointer;
        }
      }
      .litabactive:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        left: 50%;
        right: 0;
        margin-left: -20px;
        height: 3px;
        width: 50px;
        background: #fff;
      }
      .tabstext {
        margin-left: 10px;
      }
    }
  }
}

//
.newsimg-newText {
  display: flex;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 22px;
  margin: 0 auto;
  box-shadow: 0 0 10px rgb(242 242 242 / 99%);
  border-radius: 4px;
  border-width: 1px;
  margin-top: 14px;
}

// 新闻动态
.img-news {
  position: relative;
  width: 573px;
  height: 374px;
  .carousel-inner {
    position: relative;
    height: 374px;
    width: 100%;
    font-size: 0;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    > .carousel-title {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      background: rgba(0, 0, 0, 0.38);
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        display: block;
        width: 350px;
        margin: 0 20px;
        font-size: 16px;
        color: #fff;
        line-height: 1;
        transition: 0.3s;
        cursor: pointer;

        @include style-ellipsis;

        &:hover {
          @include themeify {
            color: themed('color-text-placeholder');
          }
        }
      }

      > .carousel-indicator {
        height: 40px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        visibility: hidden;
        > div {
          padding: 4px;
          border-radius: 50%;
          transition: 0.3s;
          cursor: pointer;

          @include themeify {
            background: themed('color-white');
          }

          &.active {
            @include themeify {
              background: themed('color-primary');
            }
          }

          & + div {
            margin-left: 6px;
          }
        }
      }
    }
  }

  > .carousel-indicator {
    position: absolute;
    right: 0;
    bottom: 0px;
    height: 40px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    z-index: 1;

    > div {
      padding: 6px;
      background: #fff;
      border-radius: 50%;
      transition: 0.3s;
      cursor: pointer;

      &.active {
        @include themeify {
          background: themed('color-primary');
        }
      }

      & + div {
        margin-left: 6px;
      }
    }
  }
}
// 最近更新
.text-news {
  //625
  flex: 1;
  min-width: 560px;
  margin-left: 27px;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .textnewHed {
    padding: 11px 0 13px 0px;
    display: flex;
    align-items: center;
    color: #000;

    .textnewHedleft {
      display: flex;
      flex: 1;
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;

      img {
        height: 25px;
        width: 25px;
        margin-right: 11px;
      }
    }
    
    .moreBtn{
      color: rgb(65, 146, 255);
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      cursor: pointer;
      margin-right: 18px;
    }


  }
  .tabs-main {
    padding-top: 16px;
    li {
      display: flex;
      align-items: center;
      padding-bottom: 18px;
      .bordeRou {
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #1492ff;
      }
      .titleLbae {
        width: 304px;
        margin-left: 9px;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        color: rgb(39, 38, 54);
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .titleNmae {
        max-width: 60px;
        text-align: center;
        font-size: 16px;
        font-weight: 350;
        line-height: 24px;
        color: rgb(39, 38, 54);
        margin-left: 24px;
      }
      .title-news{
        width: 20px;
        margin-left: 52px;
      }
      .title-news > span{
        display: inline-block;
        width: 20px;
        height: 20px;
        background-color: rgb(255, 102, 0);
        color: #fff;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
      }
      .titleLbaetime {
        margin-left: 30px;
        width: 83px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: rgb(153, 153, 153);
      }
    }
  }
}

// 新闻/专栏
.newsColumn{
  box-sizing: border-box;
  width: 100%;
  background-image: linear-gradient(to bottom,rgb(151, 202, 244),rgba(255, 255, 255, 0));
  padding: 22px 20px 22px 20px;
  border-radius: 4px;
  margin-top: 4px;
  display: flex;
  .newsModel{
    flex-shrink: 0;
    display: inline-block;
    width: 418px;
    height: 405px;
    background-color: #fff;
    box-shadow: 0px 1px 10px 1px rgba(0,0,0,0.05);
    padding: 10px 17px 0px 17px;
    box-sizing: border-box;
    margin-right: 18px;
    .newsModelHeader{
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0px 0px;
      padding-bottom: 9px;
      .newsTypes{
        display: flex;
        .newsTypeSwitchBtn{
          cursor: pointer;
          height: 30px;
          min-width: 77px;
          border-radius: 2px;
          background-color: transparent;
          text-align: center;
          font-weight: 500;
          font-size: 16px;
          line-height: 30px;
          color: rgb(65, 146, 255);
          margin-right: 23px;
        }
        .activeNewsTypesBtn{
          background-color: rgb(65, 146, 255);
          color: #fff;
        }
      }
      .moreBtn{
        flex-shrink: 0;
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: rgb(65, 146, 255);
      }
    }
    .newsHeaderLine{
      height: 1px;
      width: 100%;
      background-image: linear-gradient(to right, rgb(65, 146, 255), rgb(219, 65, 68));
    }
    .smallNewsListCon{
      padding: 16px 1px 0px 0px;
      li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18px;
        .newsCon{
          display: flex;
          align-items: center;
          .spot{
            width: 6px;
            height: 6px;
            background-color: rgb(65, 146, 255);
            border-radius: 50%;
            margin-right: 9px;
          }
          .newsConLable{
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            max-width: 258px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
        .newsDate{
          color: rgb(153, 153, 153);
          line-height: 24px;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  .columnModel{
    display: inline-block;
    width: 318px;
    height: 405px;
    box-shadow: 0px 1px 10px 1px rgba(0,0,0,0.05);
    background-color: #fff;
    padding: 13px 17px 6px 17px;
    box-sizing: border-box;
    .columnModelHeader{
      h2{
        margin-left: 19px;
        margin-bottom: 12px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .newsHeaderLine{
      height: 1px;
      width: 100%;
      background-image: linear-gradient(to right, rgb(65, 146, 255), rgb(219, 65, 68));
    }
    .columnListCon{
      padding-top: 10px;
      li{
        box-sizing: border-box;
        height: 58px;
        width: 100%;
        background-color: rgba(134, 131, 131, 0.3);
        background-size: 100% 100%; /* 背景图片自适应宽高 */
        background-repeat: no-repeat; /* 背景图片不重复 */
        margin-bottom: 10px;
        span{
          display: block;
          height: 58px;
          display: flex;
          align-items: center;
          padding-left: 19px;
          color: #fff;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          background-color: rgba(0, 0, 0, 0.35);
        }
      }
    }
  }
}

.tabsmainBox {
  padding-left: 45px;
  .tabs-main1 {
    padding-top: 10px;
    height: 320px;

    li {
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      .bordeRou1 {
        height: 5px;
        width: 5px;
        border-radius: 50%;
        background: #1492ff;
      }
      .titleLbae1 {
        width: 500px;
        margin-left: 10px;
        font-size: 16px;
        color: #000;
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .titleNmae1 {
        width: 130px;
        padding: 0 5px;
        font-size: 14px;
        color: #666;
      }
      .titleLbaetime1 {
        width: 150px;
        padding: 0 5px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}

.onele {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, rgb(65, 146, 255), rgb(219, 65, 68));
}


// 警种调训+学习资源+课程专题
.navtabNewimgbox {
  // height: 620px;
  width: 1200px;
  margin: 0 auto;
  // margin-top: 10px;
  .navtab {
    padding: 15px 0;
    width: 1200px;
    margin: 0 auto;
    .tabshed {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #333;
      line-height: 24px;
      .li-tab {
        cursor: pointer;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        letter-spacing: 1px;
        width: 280px;
        height: 70px;
        line-height: 70px;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 1);
        border-radius: 5px;
        -moz-box-shadow: -2px -2px 6px rgba(215, 215, 215, 0.92156862745098);
        -webkit-box-shadow: -2px -2px 6px rgb(215 215 215 / 92%);
        box-shadow: -2px -2px 6px rgb(215 215 215 / 92%);
      }
      .tabimg {
        height: 30px;
        width: 34px;
      }
      .tabstext {
        margin-left: 10px;
      }
    }
    .activeclass {
      color: #fff;
      background-color: #1492ff;
    }
  }
  .navtabStaut {
    height: 8px;
    background-color: #1492ff;
    width: 1200px;
    margin: 0 auto;
  }

  .resource-information-remedium {
    width: 1200px;
    margin: 0 auto;
    margin-top: 10px;
    .resourceInformationRemediumBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .resourceIRLeft {
        width: 850px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        .resourceIRLeftTab {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          color: #7f7f7f;
          line-height: 28px;
          height: 28px;
          padding: 20px 10px 30px 20px;
          .resourceIRLeftTabli {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            letter-spacing: 1px;
            box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
            border-radius: 5px;

            &:hover {
              cursor: pointer;
              background-color: #1492ff;
              color: #fff;
            }
          }
          .navLi:hover {
            border-bottom: solid 1px #1492ff;
          }
          // .tabstext {
          //   margin-left: 10px;
          // }
        }

        .resourceIRCount {
          border-radius: 5px;
          margin-top: 20px;
          padding: 0 10px 0 30px;
          .resourceIRCountHede {
            display: flex;
            padding-bottom: 20px;
            .resourceIRCountHedeLeft {
              height: 80px;
              width: 80px;
              // border: 1px solid #ffa200;
              color: #fff;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #ffa200;
              .resourceIRCountHedeMonth {
                font-size: 28px;
                font-weight: bold;
              }
              .resourceIRCountHedeYear {
                font-size: 14px;
                margin-top: 5px;
              }
            }
            .resourceIRCountHedeRight {
              padding-left: 30px;
              .resourceIRCountHedeLabel {
                font-size: 18px;
                color: #000;
              }
              .resourceIRCountHedeLabel:hover {
                color: #1492ff;
                cursor: pointer;
              }
              .resourceIRCountHedeBottom {
                font-size: 14px;
                color: #666;
                display: flex;
                margin-top: 10px;
              }
            }
          }
          .tablelitwo {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 14px;

            .bordeRou {
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background: #1492ff;
            }
            .dillclassName {
              // width: 700px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 10px;
              font-size: 16px;
              margin-left: 10px;
              flex: 1;
              color: #333;
              &:hover {
                color: #1492ff;
                text-decoration: underline;
                cursor: pointer;
              }
            }

            .apply {
              color: #666;
            }
          }
        }
      }
      .resourceIRRight {
        width: 270px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        padding: 20px 15px 0 15px;
        .InstructorLibraryrightlis {
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          font-size: 18px;
          height: 60px;
          line-height: 60px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            height: 30px;
            width: 30px;
          }

          .Nmaes {
            color: #000;
            margin-left: 15px;
            // width: 135px;
            flex: 1;
          }
          .sums {
            font-weight: bold;
            color: #1492ff;
          }
        }
        .InstructorLibraryrightlis:nth-child(6) {
          border-bottom: 0;
        }
      }
    }

    .resourceInformationRemediumBoxbox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .resourceIRLeftbox {
        width: 850px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        .resourceIRLeftTabboxhed {
          display: flex;
          padding: 20px 10px 30px 20px;
          color: #7f7f7f;
          .resourceIRLeftTabbox {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            justify-content: start;
            flex: 1;
            .resourceIRLeftTablibox {
              margin: 5px 10px;
              width: 100px;
              height: 28px;

              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;

              box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
              border-radius: 5px;
              &:hover {
                // color: #1492ff;
                cursor: pointer;
                // font-weight: bold;
                background-color: #1492ff;
                color: #fff;
              }
            }
          }
          .navLibox {
            width: 90px;
            font-size: 16px;
            box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .navLibox:hover {
            text-decoration: underline;
          }
        }

        .resourceIRCount {
          border-radius: 5px;
          margin-top: 20px;
          padding: 0 10px 0 30px;
          .resourceIRCountHede {
            display: flex;
            padding-bottom: 20px;
            .resourceIRCountHedeLeft {
              height: 80px;
              width: 80px;
              // border: 1px solid #ffa200;
              color: #fff;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #ffa200;
              .resourceIRCountHedeMonth {
                font-size: 28px;
                font-weight: bold;
              }
              .resourceIRCountHedeYear {
                font-size: 14px;
                margin-top: 5px;
              }
            }
            .resourceIRCountHedeRight {
              padding-left: 30px;
              .resourceIRCountHedeLabel {
                font-size: 18px;
                color: #000;
              }
              .resourceIRCountHedeLabel:hover {
                color: #1492ff;
                cursor: pointer;
              }
              .resourceIRCountHedeBottom {
                font-size: 14px;
                color: #666;
                display: flex;
                margin-top: 10px;
              }
            }
          }
          .tablelitwo {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 14px;

            .bordeRou {
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background: #1492ff;
            }
            .dillclassName {
              // width: 700px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 10px;
              font-size: 16px;
              margin-left: 10px;
              flex: 1;
              color: #333;
              &:hover {
                color: #1492ff;
                text-decoration: underline;
                cursor: pointer;
              }
            }

            .apply {
              color: #666;
            }
          }
        }
      }
      .resourceIRRight {
        width: 270px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        padding: 20px 15px 0 15px;
        .InstructorLibraryrightlis {
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          font-size: 18px;
          height: 60px;
          line-height: 60px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            height: 30px;
            width: 30px;
          }

          .Nmaes {
            color: #000;
            margin-left: 15px;
            // width: 135px;
            flex: 1;
          }
          .sums {
            font-weight: bold;
            color: #1492ff;
          }
        }
        .InstructorLibraryrightlis:nth-child(6) {
          border-bottom: 0;
        }
      }
    }
  }
}
.resourceIRLeactive {
  cursor: pointer;
  background-color: #1492ff;
  color: #fff;
}
.resourceIRLeactiveww {
  cursor: pointer;
  background-color: #1492ff;
  color: #fff !important;
  // font-weight: bold;
}

// 微警校
.training-school-inner {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 22px 24px 0px 24px;
  .training-school-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style-type: none;
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 6px;
    .leftLabel{
      display: flex;
      align-items: center;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #000;
      margin-left: 9px;
      img {
        width: 37px;
        height: 37px;
        margin-right: 13px;
      }
    }
    .gdbox {
      margin-right: 19px;
      cursor: pointer;
      color: rgb(65, 146, 255);
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
    }
    @include themeify {
      border-color: themed('color-border-base');
    }
  }
  .labelLine{
    height:2px;
    width:100%;
    background: linear-gradient(139deg, #1492ff, #d51919);
  }
  .trainingvideo {
    display: flex;
    width: 100%;

    .trainingvideright {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      
      .trainingimgli{
        cursor: pointer;
        width: 219px;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(242, 242, 242, 1);
        padding: 8px;
        margin: 0px 11px 20px 0px;
        &:hover {
          box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
        }
        img {
          width: 100%;
          height: 137px;
          border-radius: 5px;
        }
        .traingimgtext {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          padding-right: 18px;
        }
        .cityText{
          font-size: 12px;
          line-height: 18px;
          font-weight: 400;
          color: rgb(102, 102, 102);
          margin-bottom: 7px;
        }
        .traingimgnametxtlil {
          font-size: 14px;
          display: flex;
          margin-top: 6px;
          .traintext {
            padding: 3px 5px;
            color: #fff;
            background-color: rgb(100, 159, 237);
            border-radius: 4px;
            font-size: 12px;
            line-height: 18px;
            font-weight: 400;
            margin-right: 7.5px;
          }
          .trainicon {
            display: flex;
            align-items: center;
            color: #666;
            font-size: 10px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
          }
        }
      }
    }
  }
}
.navLi:hover {
  cursor: pointer;
}
// 考试咨询
.test-center-centerBox {
  margin: 0 auto;
  width: 1200px;
  box-sizing: border-box;
  padding: 26px 24px 0px 24px;
  .test-center-center {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .test-center-centerleft {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      padding-bottom: 20px;
      border-radius: 6px;
      .test-center-head {
        display: flex;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding: 0px 19px 7px 9px;
        .should {
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #000;
          margin-right: 37px;
        }
        &>img{
          height: 36px;
          width: 36px;
          margin-right: 14.5px;
        }
        .gdbox {
          flex: 1;
          text-align: right;
          font-size: 14px;
          line-height: 21px;
          color: rgb(65, 146, 255);
        }
      }

      .tableliborderlicent {
        margin-top: 20px;
        height: 445px;

        .tablelitwo {
          display: flex;
          text-align: center;
          margin-top: 10px;
          font-size: 14px;
          .dillclassName {
            width: 280px;
            font-size: 16px;
            color: #333;
            text-align: left;
            padding-left: 5px;
            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .stuat {
            height: 20px;
            width: 75px;
            border-radius: 5px;
            color: #666;
          }
          .apply {
            width: 220px;
            color: #666;
          }
          .policeclassification {
            width: 60px;
            color: #666;
          }
          .openingceremony {
            width: 220px;
            color: #666;
          }
        }
      }
    }
    .test-center-centerright {
      width: 320px;
      margin-left: 20px;
      border-radius: 6px;
      .test-center-centerrighthed {
        display: flex;
        align-items: center;
        font-weight: 500;
        text-align: center;
        padding: 0 10px 20px 0;
        img {
          width: 26px;
          height: 26px;
        }
        .should {
          font-size: 22px;
          font-weight: bold;
          color: #1492ff;
          padding-left: 10px;
        }
        .gdbox {
          flex: 1;
          text-align: right;
          font-size: 16px;
          color: #1492ff;
        }
      }
      .statisticsul {
        height: 310px;
        padding: 0 20px;
        margin-top: 20px;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(242, 242, 242, 1);
        border-radius: 5px;
        font-size: 16px;
        .statisticsli {
          display: flex;
          align-items: center;
          margin-top: 10px;
          color: #333;
          .columntext {
            display: block;
            font-size: 14px;
            padding: 0 5px;
            height: 20px;
            line-height: 20px;
            border-radius: 4px;
            border: 1px solid #333;
            white-space: nowrap;
          }
          .columntNumber {
            padding-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              color: #1492ff;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

// 教官库
.InstructorLibrary {
  margin: 0 auto;
  width: 1200px;
  margin-top: 50px;
  .InstructorLibrarybox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .InstructorLibraryleft {
      width: 900px;
      .InstructorLibraryhead {
        display: flex;
        align-items: center;
        padding: 0 0 20px 10px;
        .shoulds {
          font-size: 22px;
          font-weight: bold;
          color: #1492ff;
          padding-left: 10px;
        }
        img {
          height: 25px;
          width: 25px;
        }
        .gdboxright {
          flex: 1;
          text-align: right;
          font-size: 16px;
          cursor: pointer;
          color: #1492ff;
        }
      }
      .InstructorLibraryName {
        // padding: 30px 0 20px 0;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        // .InstructorLibraryli {
        //   width: 140px;
        //   text-align: center;
        //   cursor: pointer;

        //   border-radius: 5px;
        //   padding: 10px 0;
        //   &:hover {
        //     box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
        //     transform: scale(1.02);
        //   }
        //   img {
        //     height: 112px;
        //     width: 80px;
        //   }
        //   .name {
        //     color: #000;
        //     font-size: 16px;
        //     padding-top: 5px;
        //   }
        //   .securityName {
        //     font-size: 14px;
        //     color: #666;
        //     padding-top: 5px;
        //   }
        // }
      }
    }
    .InstructorLibraryright {
      border: 1px solid #f2f2f2;
      border-radius: 5px;
      padding: 20px 15px 0 15px;
      // width: 230px;
      // margin-left: 38px;
      .InstructorLibraryrightli {
        padding: 0 15px;
        box-sizing: border-box;
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        width: 230px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        img {
          height: 30px;
          width: 30px;
        }
        .Nmae {
          color: #000;
          margin-left: 15px;
          flex: 1;
        }
        .sum {
          font-weight: bold;
          color: #1492ff;
        }
      }
      .InstructorLibraryrightli:nth-child(4) {
        border-bottom: 0;
      }
    }
  }
}
.listli {
  // margin-top: 20px;
  display: flex;
  padding-left: 10px;
  padding: 10px 20px;
  height: 200px;
}
.listli > div {
  margin: 0 14px;
  color: #555;
  width: 140px;
  text-align: center;
  height: 200px;
  cursor: pointer;
  border-radius: 5px;
  // padding: 10px 0;
  // flex: 1;
  // 不能使用flex：1，如果数量不足六个样式会跑偏
}
.listli > div:hover {
  box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
  // border:1px solid #f2f2f2;
  // height: 210px;
  transform: scale(1.02);
}
.listli > div > div:nth-child(2) {
  color: #000;
  font-size: 16px;
  text-align: center;
  padding-top: 5px;
}
.listli > div > div:nth-child(3) {
  font-size: 14px;
  color: #666;
  padding-top: 5px;
  text-align: center;
}
.listli > div > img {
  margin-top: 16px;
  height: 112px;
  width: 80px;
  text-align: center;
}
// 学习资源
.studyRoucet {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 20px;
  .studyRoucetli {
    width: 255px;
    display: flex;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    padding: 10px 0;
    margin-bottom: 20px;
    img {
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
    .studyRoucetliRight {
      padding-left: 20px;
      .studyRoucetliRightTitle {
        width: 160px;
        font-size: 16px;
        color: #000;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .studyRoucetliRightIcon {
        display: flex;
        margin-top: 15px;
        .rigIcon-img {
          font-size: 14px;
          color: #666;
          display: flex;
          align-items: center;

          img {
            height: 16px;
            width: 16px;
          }
        }
      }
    }
  }
}

.specialbox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .speciallist {
    width: 295px;
    height: 90px;
    margin-top: 10px;
    box-sizing: border-box;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
}
// 专题
.trainingvideo {
  padding-top: 20px;
  display: flex;
  width: 1330px;
  min-height: 250px;
  .trainingvideright {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .trainingimgli {
      width: 224px;
      // height: 230px;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(242, 242, 242, 1);
      border-radius: 5px;
      padding: 10px 0;
      &:hover {
        box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
        transform: scale(1.02);
      }
      img {
        width: 222px;
        height: 136px;
        border-radius: 5px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      .traingimgtext {
        font-size: 16px;
        margin-top: 6px;
      }
      .traingimgnametxtlil {
        font-size: 14px;
        display: flex;
        margin-top: 6px;
        .traintext {
          padding: 3px 5px;
          color: #fff;
          background-color: #4876c4;
          border-radius: 4px;
          font-size: 13px;
          margin-right: 8px;
        }
        .trainicon {
          display: flex;
          align-items: center;
          color: #666;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}

.traingimgflex {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.btnirtem{
  border-radius: 15px;

}
.title-text-up:hover {
  color: rgb(0, 162, 255);
  text-decoration: underline;
  cursor: pointer;
}



.resourul {
  display: flex;
  flex-wrap: wrap;
  .resourulli {
    box-sizing: border-box;
    min-width: 77px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 30px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 2px;
    margin-right: 23px;
    color: rgb(65, 146, 255);
    &:hover {
      cursor: pointer;
      background-color: rgb(65, 146, 255);
      color: #fff;
    }
  }
}
</style>

<style scoped>
/deep/.homeExamTable .cell{
  color: rgb(39, 38, 54);
  font-size: 16px;
  line-height: 24px;
}
/deep/.homeExamTable .examtabHeader .cell{
  color: rgb(153, 153, 153);
}
</style>

